var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section"},[_vm._v(_vm._s(_vm.$t('system.errorLoadingController')))])
}
var staticRenderFns = []

export { render, staticRenderFns }